import { render } from "./MoreCardSection.vue?vue&type=template&id=4cc9563f"
import script from "./MoreCardSection.vue?vue&type=script&lang=js"
export * from "./MoreCardSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__